;(function (angular, _) {
  'use strict'

  class SelectEntityController {
    constructor (
      // Angular
      // Libs
      // Managers
      EntityManager,
      // Services
      EntityService
      // Const
      // Resolved
    ) {
      this.entityManager = EntityManager
      this.entityService = EntityService
      this.toggleContacts = false
    }

    get entity () {
      return this.ngModel.$viewValue
    }

    set entity (entity) {
      this.ngModel.$setViewValue(entity)
    }

    selectEntity () {
      return this.entityService.prompt(this.selectConfig).then((entity) => {
        this.entity = entity
      })
    }

    unSelectEntity () {
      this.entity = null
    }

    toggleInParent () {
      this.toggleContacts = !this.toggleContacts
    }

  }

  SelectEntityController.$inject = [
    // Angular
    // Libs
    // Managers
    'EntityManager',
    // Services
    'EntityService'
    // Const
    // Resolved
  ]
  angular.module('kilo.common.components')
    .component('selectEntity', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        name: '@',
        selectConfig: '<',
        disabled: '<?',
        defaultClientEmail: '=?',
        defaultClientFullName: '=?',
        showEmailSelector: '<?'
      },
      controller: SelectEntityController,
      templateUrl: '/app/common/components/select-entity/select-entity.template.html'
    })
})(window.angular, window._)
